<div class="d-flex flex-column justify-content-center align-items-center" style="height: 70vh;">
    <div><h1 class="text-danger"><i class="bi bi-shield-lock"></i></h1></div>
    <div><h4>You don't have permission to view this page.</h4></div>
    <div><p>Contact an administrator to get permission or try navigating with the option below.</p></div>
    <div class="mt-2">
        <button class="btn btn-danger" (click)="logout()"><i class="bi bi-box-arrow-left mx-1"></i>Logout</button>
        <button class="btn btn-primary mx-1" (click)="goToHome()"><i class="bi bi-house-door-fill mx-1"></i>Homepage</button>
    </div>
</div>
